import { render, staticRenderFns } from "./FreightLines.vue?vue&type=template&id=ba900bac&scoped=true&"
import script from "./FreightLines.vue?vue&type=script&lang=js&"
export * from "./FreightLines.vue?vue&type=script&lang=js&"
import style0 from "./FreightLines.vue?vue&type=style&index=0&id=ba900bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba900bac",
  null
  
)

/* custom blocks */
import block0 from "./FreightLines.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports